import { AUTH_COOKIES } from '@libs/core';
import Cookies from 'js-cookie';

/** @deprecated replace with getAccessToken from libs/core/src/utils/cookies.ts */
export const getAccessToken = () => Cookies.get(AUTH_COOKIES.ACCESS_TOKEN) ?? '';
